import { Controller } from "@hotwired/stimulus"
import { Swiper } from "swiper"
import { Navigation, Pagination, Autoplay } from "swiper/modules"
import "swiper/swiper-bundle.css"

// Generic Swiper wrapper — one controller, driven entirely by data attributes,
// so the same controller powers both the full-bleed hero carousel and the
// small looping partner-logos strip without needing two near-duplicate files.
//
// Usage (see home/index.html.erb):
//   data-controller="swiper-slider"
//   data-swiper-slider-loop-value="true"
//   data-swiper-slider-autoplay-value="6000"      (ms, omit/0 to disable)
//   data-swiper-slider-slides-per-view-value="1"  (number or "auto")
//   data-swiper-slider-space-between-value="0"
//   data-swiper-slider-navigation-value="true"    (arrows)
//   data-swiper-slider-pagination-value="true"    (dots)
export default class extends Controller {
  static values = {
    loop: { type: Boolean, default: false },
    autoplay: { type: Number, default: 0 },
    slidesPerView: { type: String, default: "1" },
    spaceBetween: { type: Number, default: 0 },
    navigation: { type: Boolean, default: false },
    pagination: { type: Boolean, default: false },
    breakpoints: { type: Object, default: {} }
  }

  connect() {
    const slidesPerView = this.slidesPerViewValue === "auto" ? "auto" : Number(this.slidesPerViewValue)

    this.swiper = new Swiper(this.element, {
      modules: [Navigation, Pagination, Autoplay],
      loop: this.loopValue,
      slidesPerView,
      spaceBetween: this.spaceBetweenValue,
      breakpoints: Object.keys(this.breakpointsValue).length ? this.breakpointsValue : undefined,
      autoplay: this.autoplayValue > 0
        ? { delay: this.autoplayValue, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      navigation: this.navigationValue
        ? { nextEl: this.element.querySelector(".swiper-button-next"), prevEl: this.element.querySelector(".swiper-button-prev") }
        : false,
      pagination: this.paginationValue
        ? { el: this.element.querySelector(".swiper-pagination"), clickable: true }
        : false
    })
  }

  disconnect() {
    // Prevent duplicate Swiper instances / memory leaks across Turbo page visits.
    this.swiper?.destroy(true, true)
  }
}
